/**
 * Created by brandonong on 23/12/17.
 */
import React, {Component} from 'react';
import './App.css';
import {Field, FieldArray, reduxForm, formValueSelector} from 'redux-form';
import {connect} from 'react-redux';
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
const selector = formValueSelector('fieldArrays');



class DeliveryAddresses extends React.Component {


    constructor(props) {
        super(props)
        this.state = {
            shippingval: []
        }
    }

    shippingVal() {
        if (this.props.shippingaddress !== undefined) {
            const shippingval = this.props.shippingaddress.map((country) =>
                Object.values(country).length === 0
            )
            return (shippingval.some(boolean => boolean === true))
        }
    }

    render() {
        const {numberofbox, differentaddress, oos} = this.props;
        const boxarray = [
            <MenuItem value="Dreamer" disabled={oos} primaryText={`Dorothy, Dreamer - USD 59 ${oos ? '(Out of Stock)' : ''}`}/>,
            <MenuItem value="Courage" disabled={oos} primaryText={`Cowardly Lion, Courage - USD 45 ${oos ? '(Out of Stock)' : ''}`}/>,
            <MenuItem value="Intelligence" disabled={oos} primaryText={`Scarecrow, Intelligence - USD 35 ${oos ? '(Out of Stock)' : ''}`}/>,
            <MenuItem value="Kindness" disabled={oos} primaryText={`Tin Man, Kindness - USD 29 ${oos ? '(Out of Stock)' : ''}`}/>,
            <MenuItem value="Verve" disabled={oos} primaryText={`Verve - USD 55 ${oos ? '(Out of Stock)' : ''}`}/>,
            <MenuItem value="Vulnerability" disabled={oos} primaryText={`Vulnerability - USD 48 ${oos ? '(Out of Stock)' : ''}`}/>
        ]
        const onebox = parseFloat(numberofbox) === 1
        const morethanonebutsameadd = parseFloat(numberofbox) > 1 && !differentaddress
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return (
            <form onSubmit={this.props.handleSubmit}>
                <h3>Please enter your Shipping Details</h3>
                {onebox || morethanonebutsameadd
                    ?
                    <div>
                        <div>
                            <Field
                                label={`Receiver's Name`}
                                name={`recname`}
                                placeholder="Name of person receiving (optional)"
                                component={renderTextField}
                            />
                        </div>
                        <div>
                            <Field
                                label={`Type of Box`}
                                name={`typeofbox`}
                                placeholder="Type of Box"
                                component={renderSelectField}
                            >
                                {boxarray}
                            </Field>
                        </div>
                        <div>
                            <Field
                                label="Country"
                                name="country"
                                component={renderSelectField}
                            >
                                {newcountryarray}
                            </Field>
                        </div>
                        <div>
                            <Field
                                label="Street Address"
                                name="streetaddress"
                                placeholder="House number and streetname"
                                component={renderTextField}
                            />
                        </div>
                        <div>
                            <Field
                                name="optionalstreetaddress"
                                placeholder="Apartment, suite, unit etc. (optional)"
                                component={renderTextFieldnoLabel}
                            />
                        </div>
                        <div>
                            <Field
                                label="Town/City"
                                name="towncity"
                                component={renderTextField}
                            />
                        </div>
                        <div>
                            <Field
                                label="Postal Code/ZIP"
                                name="postalcodezip"
                                component={renderTextField}
                            />
                        </div>
                        <h3>Please enter your Contact Details</h3>
                        <div>
                            <Field
                                label="Your Name"
                                name="yourname"
                                component={renderTextField}
                            />
                        </div>
                        <div>
                            <Field
                                label="Phone Number"
                                name="phoneno"
                                component={renderTextField}
                            />
                        </div>
                        <div>
                            <Field
                                label="Email Address"
                                name="emailaddress"
                                component={renderTextField}
                            />
                        </div>
                    </div>
                    :
                    <div>
                        <FieldArray name="shippingaddresses" component={renderAddresses} oos={oos}/>
                        <h3>Please enter your Contact Details</h3>
                        <div>
                            <Field
                                label="Your Name"
                                name="yourname"
                                component={renderTextField}
                            />
                        </div>
                        <div>
                            <Field
                                label="Phone Number"
                                name="phoneno"
                                component={renderTextField}
                            />
                        </div>
                        <div>
                            <Field
                                label="Email Address"
                                name="emailaddress"
                                component={renderTextField}
                                type="email"
                            />
                        </div>
                    </div>

                }
                {onebox || morethanonebutsameadd
                    ?
                    <div className="buttoncontainer">
                        <RaisedButton label="Previous" primary={true}
                                      onClick={this.props.onClickPrev} style={{padding: "10px, 36px"}}
                                      buttonStyle={{borderRadius: "5px"}}/>
                        <RaisedButton label="Next" secondary={true} type="submit" disabled={this.props.country === undefined || !re.test(this.props.emailaddress)}
                                      style={{padding: "10px, 36px"}} buttonStyle={{borderRadius: "5px"}}/>
                    </div>
                    :
                    <div className="buttoncontainer">
                        <RaisedButton label="Previous" primary={true}
                                      onClick={this.props.onClickPrev} style={{padding: "10px, 36px"}}
                                      buttonStyle={{borderRadius: "5px"}}/>
                        <RaisedButton label="Next" secondary={true} type="submit" disabled={this.shippingVal() || !re.test(this.props.emailaddress)}
                                      style={{padding: "10px, 36px"}} buttonStyle={{borderRadius: "5px"}}/>
                    </div>
                }
            </form>
        )
    }
}

class renderAddresses extends React.Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        const {fields, numberofbox} = this.props;
        let boxlength = numberofbox
        console.log(boxlength)
        let step;
        if (boxlength > fields.length) {
            for (step = 0; step < (boxlength - fields.length); step++) {
                fields.push({})
            }
        } else if (boxlength < fields.length) {
            for (step = 0; step > (boxlength - fields.length); step--) {
                fields.remove()
            }
        }
    }

    render() {
        const {fields, oos} = this.props;
        const boxarray = [
            <MenuItem value="Dreamer" disabled={oos} primaryText={`Dorothy, Dreamer - USD 59 ${oos ? '(Out of Stock)' : ''}`}/>,
            <MenuItem value="Courage" disabled={oos} primaryText={`Cowardly Lion, Courage - USD 45 ${oos ? '(Out of Stock)' : ''}`}/>,
            <MenuItem value="Intelligence" disabled={oos} primaryText={`Scarecrow, Intelligence - USD 35 ${oos ? '(Out of Stock)' : ''}`}/>,
            <MenuItem value="Kindness" disabled={oos} primaryText={`Tin Man, Kindness - USD 29 ${oos ? '(Out of Stock)' : ''}`}/>,
            <MenuItem value="Verve" disabled={oos} primaryText={`Verve - USD 55 ${oos ? '(Out of Stock)' : ''}`}/>,
            <MenuItem value="Vulnerability" disabled={oos} primaryText={`Vulnerability - USD 48 ${oos ? '(Out of Stock)' : ''}`}/>
        ]
        return (
            <ul className="dogchoice">
                {fields.map((address, index) => (
                    <div className="deliveryeachli">
                    <li key={`box.${index}`}>
                        <h3><span>Box #{index+1}</span></h3>
                        <div>
                            <Field
                                label={`Receiver's Name ${index + 1}`}
                                name={`${address}.recname`}
                                placeholder="Name of person receiving (optional)"
                                component={renderTextField}
                            />
                        </div>
                        <div>
                            <Field
                                label={`Type of Box ${index + 1}`}
                                name={`${address}.typeofbox`}
                                placeholder="Type of Box"
                                component={renderSelectField}
                            >
                                {boxarray}
                            </Field>
                        </div>
                        <div>
                            <Field
                                label={`Country ${index + 1}`}
                                name={`${address}.country`}
                                component={renderSelectField}
                            >
                                {newcountryarray}
                            </Field>
                        </div>
                        <div>
                            <Field
                                label={`Street Address ${index + 1}`}
                                name={`${address}.streetaddress`}
                                placeholder="House number and streetname"
                                component={renderTextField}
                            />
                        </div>
                        <div>
                            <Field
                                name={`${address}.optionalstreetaddress`}
                                placeholder="Apartment, suite, unit etc. (optional)"
                                component={renderTextFieldnoLabel}
                            />
                        </div>
                        <div>
                            <Field
                                label={`Town/City ${index + 1}`}
                                name={`${address}.towncity`}
                                component={renderTextField}
                            />
                        </div>
                        <div>
                            <Field
                                label={`Postal Code/ZIP ${index + 1}`}
                                name={`${address}.postalcodezip`}
                                component={renderTextField}
                            />
                        </div>
                    </li>
                    </div>
                ))}
            </ul>
        )
    }
}

const renderSelectField = ({
                               input,
                               label,
    name,
                               meta: {touched, error},
                               children,
                               ...custom
                           }) => (
    <div>
        <label for={name}>{label}</label>
        <SelectField
            errorText={touched && error}
            {...input}
            onChange={(event, index, value) => input.onChange(value)}
            children={children}
            {...custom}
            maxHeight={200}
            underlineStyle={{borderBottom:"none"}}
            style={{border:"1px solid #e4d6cf", borderRadius:"5px", backgroundColor:"#fdfdfd", paddingLeft:"10px"}}
            menuStyle={{paddingLeft:"-10px"}}
            fullWidth={true}
        />
    </div>
)



const renderTextField = ({
                             input,
                             label,
    type,
    name,
                             placeholder,
                             meta: {touched, error},
                             ...custom
                         }) => (
    <div>
        <label for={name}>{label}</label>
    <TextField
        hintText={placeholder}
        errorText={touched && error}
        type={type}
        fullWidth={true}
        style={{border:"1px solid #e4d6cf", borderRadius:"5px", backgroundColor:"#fdfdfd", paddingLeft:"10px", transition:"border-color .15s ease-in-out,box-shadow .15s ease-in-out"}}
        underlineStyle={{borderBottom:"none"}}
        {...input}
        {...custom}
    />
    </div>
)

const renderTextFieldnoLabel = ({
                                    input,
                                    placeholder,
                                    meta: {touched, error},
                                    ...custom
                                }) => (
    <TextField
        hintText={placeholder}
        errorText={touched && error}
        fullWidth={true}
        style={{margin:"5px 0 10px 0", border:"1px solid #e4d6cf", borderRadius:"5px", backgroundColor:"#fdfdfd", paddingLeft:"10px", transition:"border-color .15s ease-in-out,box-shadow .15s ease-in-out"}}
        underlineStyle={{borderBottom:"none"}}
        {...input}
        {...custom}
    />
)

const countryarray = [
    {},
    {name: 'Singapore', code: 'SG'},
    {name: 'Australia', code: 'AU'},
    {name: 'Afghanistan', code: 'AF'},
    {name: 'Åland Islands', code: 'AX'},
    {name: 'Albania', code: 'AL'},
    {name: 'Algeria', code: 'DZ'},
    {name: 'American Samoa', code: 'AS'},
    {name: 'Andorra', code: 'AD'},
    {name: 'Angola', code: 'AO'},
    {name: 'Anguilla', code: 'AI'},
    {name: 'Antarctica', code: 'AQ'},
    {name: 'Antigua and Barbuda', code: 'AG'},
    {name: 'Argentina', code: 'AR'},
    {name: 'Armenia', code: 'AM'},
    {name: 'Aruba', code: 'AW'},
    {name: 'Austria', code: 'AT'},
    {name: 'Azerbaijan', code: 'AZ'},
    {name: 'Bahamas', code: 'BS'},
    {name: 'Bahrain', code: 'BH'},
    {name: 'Bangladesh', code: 'BD'},
    {name: 'Barbados', code: 'BB'},
    {name: 'Belarus', code: 'BY'},
    {name: 'Belgium', code: 'BE'},
    {name: 'Belize', code: 'BZ'},
    {name: 'Benin', code: 'BJ'},
    {name: 'Bermuda', code: 'BM'},
    {name: 'Bhutan', code: 'BT'},
    {name: 'Bolivia', code: 'BO'},
    {name: 'Bosnia and Herzegovina', code: 'BA'},
    {name: 'Botswana', code: 'BW'},
    {name: 'Bouvet Island', code: 'BV'},
    {name: 'Brazil', code: 'BR'},
    {name: 'British Indian Ocean Territory', code: 'IO'},
    {name: 'Brunei Darussalam', code: 'BN'},
    {name: 'Bulgaria', code: 'BG'},
    {name: 'Burkina Faso', code: 'BF'},
    {name: 'Burundi', code: 'BI'},
    {name: 'Cambodia', code: 'KH'},
    {name: 'Cameroon', code: 'CM'},
    {name: 'Canada', code: 'CA'},
    {name: 'Cape Verde', code: 'CV'},
    {name: 'Cayman Islands', code: 'KY'},
    {name: 'Central African Republic', code: 'CF'},
    {name: 'Chad', code: 'TD'},
    {name: 'Chile', code: 'CL'},
    {name: 'China', code: 'CN'},
    {name: 'Christmas Island', code: 'CX'},
    {name: 'Cocos (Keeling) Islands', code: 'CC'},
    {name: 'Colombia', code: 'CO'},
    {name: 'Comoros', code: 'KM'},
    {name: 'Congo', code: 'CG'},
    {name: 'Congo, The Democratic Republic of the', code: 'CD'},
    {name: 'Cook Islands', code: 'CK'},
    {name: 'Costa Rica', code: 'CR'},
    {name: 'Cote D\'Ivoire', code: 'CI'},
    {name: 'Croatia', code: 'HR'},
    {name: 'Cuba', code: 'CU'},
    {name: 'Cyprus', code: 'CY'},
    {name: 'Czech Republic', code: 'CZ'},
    {name: 'Denmark', code: 'DK'},
    {name: 'Djibouti', code: 'DJ'},
    {name: 'Dominica', code: 'DM'},
    {name: 'Dominican Republic', code: 'DO'},
    {name: 'Ecuador', code: 'EC'},
    {name: 'Egypt', code: 'EG'},
    {name: 'El Salvador', code: 'SV'},
    {name: 'Equatorial Guinea', code: 'GQ'},
    {name: 'Eritrea', code: 'ER'},
    {name: 'Estonia', code: 'EE'},
    {name: 'Ethiopia', code: 'ET'},
    {name: 'Falkland Islands (Malvinas)', code: 'FK'},
    {name: 'Faroe Islands', code: 'FO'},
    {name: 'Fiji', code: 'FJ'},
    {name: 'Finland', code: 'FI'},
    {name: 'France', code: 'FR'},
    {name: 'French Guiana', code: 'GF'},
    {name: 'French Polynesia', code: 'PF'},
    {name: 'French Southern Territories', code: 'TF'},
    {name: 'Gabon', code: 'GA'},
    {name: 'Gambia', code: 'GM'},
    {name: 'Georgia', code: 'GE'},
    {name: 'Germany', code: 'DE'},
    {name: 'Ghana', code: 'GH'},
    {name: 'Gibraltar', code: 'GI'},
    {name: 'Greece', code: 'GR'},
    {name: 'Greenland', code: 'GL'},
    {name: 'Grenada', code: 'GD'},
    {name: 'Guadeloupe', code: 'GP'},
    {name: 'Guam', code: 'GU'},
    {name: 'Guatemala', code: 'GT'},
    {name: 'Guernsey', code: 'GG'},
    {name: 'Guinea', code: 'GN'},
    {name: 'Guinea-Bissau', code: 'GW'},
    {name: 'Guyana', code: 'GY'},
    {name: 'Haiti', code: 'HT'},
    {name: 'Heard Island and Mcdonald Islands', code: 'HM'},
    {name: 'Holy See (Vatican City State)', code: 'VA'},
    {name: 'Honduras', code: 'HN'},
    {name: 'Hong Kong', code: 'HK'},
    {name: 'Hungary', code: 'HU'},
    {name: 'Iceland', code: 'IS'},
    {name: 'India', code: 'IN'},
    {name: 'Indonesia', code: 'ID'},
    {name: 'Iran, Islamic Republic Of', code: 'IR'},
    {name: 'Iraq', code: 'IQ'},
    {name: 'Ireland', code: 'IE'},
    {name: 'Isle of Man', code: 'IM'},
    {name: 'Israel', code: 'IL'},
    {name: 'Italy', code: 'IT'},
    {name: 'Jamaica', code: 'JM'},
    {name: 'Japan', code: 'JP'},
    {name: 'Jersey', code: 'JE'},
    {name: 'Jordan', code: 'JO'},
    {name: 'Kazakhstan', code: 'KZ'},
    {name: 'Kenya', code: 'KE'},
    {name: 'Kiribati', code: 'KI'},
    {name: 'Korea, Democratic People\'S Republic of', code: 'KP'},
    {name: 'Korea, Republic of', code: 'KR'},
    {name: 'Kuwait', code: 'KW'},
    {name: 'Kyrgyzstan', code: 'KG'},
    {name: 'Lao People\'S Democratic Republic', code: 'LA'},
    {name: 'Latvia', code: 'LV'},
    {name: 'Lebanon', code: 'LB'},
    {name: 'Lesotho', code: 'LS'},
    {name: 'Liberia', code: 'LR'},
    {name: 'Libyan Arab Jamahiriya', code: 'LY'},
    {name: 'Liechtenstein', code: 'LI'},
    {name: 'Lithuania', code: 'LT'},
    {name: 'Luxembourg', code: 'LU'},
    {name: 'Macao', code: 'MO'},
    {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'},
    {name: 'Madagascar', code: 'MG'},
    {name: 'Malawi', code: 'MW'},
    {name: 'Malaysia', code: 'MY'},
    {name: 'Maldives', code: 'MV'},
    {name: 'Mali', code: 'ML'},
    {name: 'Malta', code: 'MT'},
    {name: 'Marshall Islands', code: 'MH'},
    {name: 'Martinique', code: 'MQ'},
    {name: 'Mauritania', code: 'MR'},
    {name: 'Mauritius', code: 'MU'},
    {name: 'Mayotte', code: 'YT'},
    {name: 'Mexico', code: 'MX'},
    {name: 'Micronesia, Federated States of', code: 'FM'},
    {name: 'Moldova, Republic of', code: 'MD'},
    {name: 'Monaco', code: 'MC'},
    {name: 'Mongolia', code: 'MN'},
    {name: 'Montserrat', code: 'MS'},
    {name: 'Morocco', code: 'MA'},
    {name: 'Mozambique', code: 'MZ'},
    {name: 'Myanmar', code: 'MM'},
    {name: 'Namibia', code: 'NA'},
    {name: 'Nauru', code: 'NR'},
    {name: 'Nepal', code: 'NP'},
    {name: 'Netherlands', code: 'NL'},
    {name: 'Netherlands Antilles', code: 'AN'},
    {name: 'New Caledonia', code: 'NC'},
    {name: 'New Zealand', code: 'NZ'},
    {name: 'Nicaragua', code: 'NI'},
    {name: 'Niger', code: 'NE'},
    {name: 'Nigeria', code: 'NG'},
    {name: 'Niue', code: 'NU'},
    {name: 'Norfolk Island', code: 'NF'},
    {name: 'Northern Mariana Islands', code: 'MP'},
    {name: 'Norway', code: 'NO'},
    {name: 'Oman', code: 'OM'},
    {name: 'Pakistan', code: 'PK'},
    {name: 'Palau', code: 'PW'},
    {name: 'Palestinian Territory, Occupied', code: 'PS'},
    {name: 'Panama', code: 'PA'},
    {name: 'Papua New Guinea', code: 'PG'},
    {name: 'Paraguay', code: 'PY'},
    {name: 'Peru', code: 'PE'},
    {name: 'Philippines', code: 'PH'},
    {name: 'Pitcairn', code: 'PN'},
    {name: 'Poland', code: 'PL'},
    {name: 'Portugal', code: 'PT'},
    {name: 'Puerto Rico', code: 'PR'},
    {name: 'Qatar', code: 'QA'},
    {name: 'Reunion', code: 'RE'},
    {name: 'Romania', code: 'RO'},
    {name: 'Russian Federation', code: 'RU'},
    {name: 'RWANDA', code: 'RW'},
    {name: 'Saint Helena', code: 'SH'},
    {name: 'Saint Kitts and Nevis', code: 'KN'},
    {name: 'Saint Lucia', code: 'LC'},
    {name: 'Saint Pierre and Miquelon', code: 'PM'},
    {name: 'Saint Vincent and the Grenadines', code: 'VC'},
    {name: 'Samoa', code: 'WS'},
    {name: 'San Marino', code: 'SM'},
    {name: 'Sao Tome and Principe', code: 'ST'},
    {name: 'Saudi Arabia', code: 'SA'},
    {name: 'Senegal', code: 'SN'},
    {name: 'Serbia and Montenegro', code: 'CS'},
    {name: 'Seychelles', code: 'SC'},
    {name: 'Sierra Leone', code: 'SL'},
    {name: 'Slovakia', code: 'SK'},
    {name: 'Slovenia', code: 'SI'},
    {name: 'Solomon Islands', code: 'SB'},
    {name: 'Somalia', code: 'SO'},
    {name: 'South Africa', code: 'ZA'},
    {name: 'South Georgia and the South Sandwich Islands', code: 'GS'},
    {name: 'Spain', code: 'ES'},
    {name: 'Sri Lanka', code: 'LK'},
    {name: 'Sudan', code: 'SD'},
    {name: 'Suriname', code: 'SR'},
    {name: 'Svalbard and Jan Mayen', code: 'SJ'},
    {name: 'Swaziland', code: 'SZ'},
    {name: 'Sweden', code: 'SE'},
    {name: 'Switzerland', code: 'CH'},
    {name: 'Syrian Arab Republic', code: 'SY'},
    {name: 'Taiwan, Province of China', code: 'TW'},
    {name: 'Tajikistan', code: 'TJ'},
    {name: 'Tanzania, United Republic of', code: 'TZ'},
    {name: 'Thailand', code: 'TH'},
    {name: 'Timor-Leste', code: 'TL'},
    {name: 'Togo', code: 'TG'},
    {name: 'Tokelau', code: 'TK'},
    {name: 'Tonga', code: 'TO'},
    {name: 'Trinidad and Tobago', code: 'TT'},
    {name: 'Tunisia', code: 'TN'},
    {name: 'Turkey', code: 'TR'},
    {name: 'Turkmenistan', code: 'TM'},
    {name: 'Turks and Caicos Islands', code: 'TC'},
    {name: 'Tuvalu', code: 'TV'},
    {name: 'Uganda', code: 'UG'},
    {name: 'Ukraine', code: 'UA'},
    {name: 'United Arab Emirates', code: 'AE'},
    {name: 'United Kingdom', code: 'GB'},
    {name: 'United States', code: 'US'},
    {name: 'United States Minor Outlying Islands', code: 'UM'},
    {name: 'Uruguay', code: 'UY'},
    {name: 'Uzbekistan', code: 'UZ'},
    {name: 'Vanuatu', code: 'VU'},
    {name: 'Venezuela', code: 'VE'},
    {name: 'Viet Nam', code: 'VN'},
    {name: 'Virgin Islands, British', code: 'VG'},
    {name: 'Virgin Islands, U.S.', code: 'VI'},
    {name: 'Wallis and Futuna', code: 'WF'},
    {name: 'Western Sahara', code: 'EH'},
    {name: 'Yemen', code: 'YE'},
    {name: 'Zambia', code: 'ZM'},
    {name: 'Zimbabwe', code: 'ZW'}
];

const newcountryarray = []
for (let i = 1; i < countryarray.length; i++) {
    newcountryarray.push(<MenuItem value={`${countryarray[i]["code"]}`} key={i}
                                   primaryText={`${countryarray[i]["name"]}`}/>);
}

DeliveryAddresses = connect(
    state => {
        const numberofbox = selector(state, 'numberofbox');
        const typeofbox = selector(state, 'typeofbox');
        const differentaddress = selector(state, 'differentaddress');
        const emailaddress = selector(state, 'emailaddress');
        const shippingaddress = selector(state, 'shippingaddresses')
        const phoneno = selector(state, 'phoneno');
        const country = selector(state, 'country');
        const country0 = selector(state, 'country0');
        const country1 = selector(state, 'country1');
        const country2 = selector(state, 'country2');
        const country3 = selector(state, 'country3');
        const country4 = selector(state, 'country4');
        const country5 = selector(state, 'country5');
        const country6 = selector(state, 'country6');
        const country7 = selector(state, 'country7');
        const country8 = selector(state, 'country8');
        const country9 = selector(state, 'country9');
        const country10 = selector(state, 'country10');
        const country11 = selector(state, 'country11');
        const country12 = selector(state, 'country12');
        const country13 = selector(state, 'country13');
        const country14 = selector(state, 'country14');
        const country15 = selector(state, 'country15');
        const country16 = selector(state, 'country16');
        const country17 = selector(state, 'country17');
        const country18 = selector(state, 'country18');
        const country19 = selector(state, 'country19');

        return {
            typeofbox, shippingaddress, numberofbox, differentaddress, emailaddress, phoneno, country, country0,country1,country2,country3,country4,country5,country6,country7,country8,country9,country10,country11,country12,country13,country14,country15,country16,country17,country18,country19,
        }
    }
)(DeliveryAddresses);

renderAddresses = connect(
    state => {
        const numberofbox = selector(state, 'numberofbox');
        const differentaddress = selector(state, 'differentaddress');

        return {
            numberofbox, differentaddress
        }
    }
)(renderAddresses);


export default reduxForm({
    form: 'fieldArrays', // <------ same form name
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(DeliveryAddresses)


// WEBPACK FOOTER //
// ./src/DeliveryAddresses.js